import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Apps",
  "use": "Apps-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Apps\"><path d=\"M3 17h14V3H3zm22 0h14V3H25zm22 0h14V3H47zM3 38h14V24H3zm22 0h14V24H25zm22 0h14V24H47zM3 60h14V46H3zm22 0h14V46H25zm22 0h14V46H47z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol